import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { CostCenterService } from '../proxy/controlling/controllers/cost-center.service';
import { DocumentTypeService } from '../proxy/controlling/controllers/document-type.service';
import { ProfitCenterService } from '../proxy/controlling/controllers/profit-center.service';
import { AccountService } from '../proxy/controlling/controllers/account.service';
import { ContractTypeService } from '../proxy/controlling/controllers/contract-type.service';
import { InternalOrderService } from '../proxy/controlling/controllers/internal-order.service';
import { ServiceMasterService } from '../proxy/controlling/controllers/service-master.service';
import { RegionService } from '@planning/proxy/planning/controllers/region.service';
import { PropertyTypeService } from '@planning/proxy/planning/controllers/property-type.service';

FieldBuilder.setNamespace('Controlling');

export const PROPERTYTYPEREGIONPARAMETER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('propertyTypeId', 'Entity.PropertyTypeRegionParameter.PropertyType', PropertyTypeService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .foreignKey('serviceMasterId', 'Entity.PropertyTypeRegionParameter.ServiceMaster', ServiceMasterService)
    .displayFromNested('serviceMaster.name')
    .sortBy('serviceMaster.name')
    .build(),
  FieldBuilder
    .checkbox('isDirectActivity', 'Entity.PropertyTypeRegionParameter.IsDirectActivity')
    .build(),
  FieldBuilder.foreignKey(
    'costCenterId',
    'Entity.CostCenter',
    CostCenterService
  )
    .required()
    .displayFromNested('costCenter.sapCode')
    .sortBy('costCenter.sapCode')
    .build(),
  FieldBuilder.foreignKey(
    'sapDocumentTypeId',
    'Entity.PropertyTypeRegionParameter.SapDocumentType',
    DocumentTypeService
  )
    .required()
    .displayFromNested('documentType.name')
    .sortBy('documentType.name')
    .build(),
  FieldBuilder.foreignKey(
    'profitCenterId',
    'Entity.ProfitCenter',
    ProfitCenterService
  )
    .displayFromNested('profitCenter.sapCode')
    .sortBy('profitCenter.sapCode')
    .build(),
  FieldBuilder.foreignKey(
    'accountId',
    'Entity.Account',
    AccountService
  )
    .displayFromNested('account.name')
    .sortBy('account.name')
    .build(),
  FieldBuilder.foreignKey(
    'contractTypeId',
    'Entity.ContractType',
    ContractTypeService
  )
    .displayFromNested('contractType.name')
    .sortBy('contractType.name')
    .build(),
  FieldBuilder.foreignKey(
    'internalOrderId',
    'Entity.InternalOrder',
    InternalOrderService
  )
    .displayFromNested('internalOrder.name')
    .sortBy('internalOrder.name')
    .build(),
  FieldBuilder.foreignKey(
    'regionId',
    'Entity.PropertyTypeRegionParameter.Region',
    RegionService
  )
    .required()
    .displayFromNested('region.name')
    .sortBy('region.name')
    .build(),
];

export const PROPERTYTYPEREGIONPARAMETER_CONFIG = {
  entityName: 'PropertyTypeRegionParameter',
  localizationKey: 'Controlling::Entity.PropertyTypeRegionParameter',
  fields: PROPERTYTYPEREGIONPARAMETER_FIELDS,
  permission: 'ControllingLiquidations.PropertyTypeRegionParameters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
